// extracted by mini-css-extract-plugin
export default {"title":"ResetPassword_title__qcONz"};